export enum RoleId {
  ADMINISTRADOR = 1,
  GESTOR = 2,
  EDITOR = 3,
}

export interface RoleModel {
  id: number;
  name: string;
  description?: string;
  guard_name?: string;
  created_at: string;
  updated_at: string;
  permissions?: PermissionModel[];
}

export interface PermissionModel {
  id: number;
  name: string;
  display_name: string;
}

export interface PermissionGroup {
  [group: string]: PermissionModel[];
}

export interface GetRolesResponse {
  success: boolean;
  message: string;
  data: RoleModel[];
}

export interface GetRoleResponse {
  success: boolean;
  message: string;
  data: RoleModel;
}

export interface GetPermissionsGroupedResponse {
  success: boolean;
  message: string;
  data: PermissionGroup;
}

export interface CreateRoleRequestDto {
  name: string;
  description?: string;
  permissions?: string[];
}

export interface CreateRoleResponse {
  success: boolean;
  message: string;
  data: RoleModel;
}

export interface UpdateRoleRequestDto {
  name: string;
  description?: string;
  permissions?: string[];
}

export interface UpdateRoleResponse {
  success: boolean;
  message: string;
  data: RoleModel;
}

export interface DeleteRoleResponse {
  success: boolean;
  message: string;
}
